import { render, staticRenderFns } from "./AddToStandard.vue?vue&type=template&id=e516e482&"
import script from "./AddToStandard.vue?vue&type=script&lang=js&"
export * from "./AddToStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports